import React from 'react';

import { CallTextNumberContainer, ModalContentContainer } from './ModalContent.styled';
import { Text } from 'components/v2/Typography/Text';
import { LabInfo } from 'kb-shared/utilities/kindbody_contacts';

export const ModalContent = ({ lab }: { lab: LabInfo }) => {
  return (
    <ModalContentContainer>
      <CallTextNumberContainer>
        <Text>
          If you have more questions please call our office at{' '}
          <a href={`tel:${lab.number}`}>
            <strong>{lab.number}</strong>
          </a>{' '}
          at any time. Urgent medical questions will be routed to our on-call care team after hours.
        </Text>
      </CallTextNumberContainer>
    </ModalContentContainer>
  );
};
